/* ============================================================
   ATLAS · VF RUNTIME— VF CORE
   Responsabilità:
   - sessioni (guest)
   - build config VF
   - initVF
   - dispatch eventi (NO UI)
============================================================ */
  (function () {
  'use strict';

  function waitForAtlasAndStart() {
    if (!window.ATLAS?.core?.config) {
      return setTimeout(waitForAtlasAndStart, 300);
    }
    startCore();
  }

  function startCore() {

    /* ============================
       GUARD RAIL: ATLAS CORE
    ============================ */
    function waitForAtlasCore(max = 50) {
      return new Promise((resolve, reject) => {
        let tries = 0;
        const check = () => {
          if (
            window.ATLAS?.core?.config &&
            window.ATLAS?.core?.runtime &&
            window.ATLAS?.core?.storage
          ) {
            resolve();
          } else if (++tries >= max) {
            reject();
          } else {
            setTimeout(check, 100);
          }
        };
        check();
      });
    }

    const FLAGS = window.__ATLAS_FLAGS__ = window.__ATLAS_FLAGS__ || {};

    const {
      VOICEFLOW_PROJECT_ID,
      VOICEFLOW_RUNTIME_URL
    } = ATLAS.core.config;

    const {
      SESSION_KEY,
      VF_GUEST_KEY,
      VF_SESSION_KEY
    } = ATLAS.core.storage;

    /* ============================
       SESSION MANAGEMENT
    ============================ */
    function createGuestSession() {
      const guest = {
        id: 'guest_' + Math.random().toString(36).slice(2),
        ts: Date.now()
      };
      try {
        sessionStorage.setItem(VF_GUEST_KEY, JSON.stringify(guest));
      } catch {}
      return guest;
    }

    function readStoredVFUser() {
      try {
        const s = sessionStorage.getItem(VF_SESSION_KEY);
        return s ? JSON.parse(s) : null;
      } catch {
        return null;
      }
    }

    async function initSessionEngine() {
      const stored = readStoredVFUser();
      if (stored) {
        window.ATLAS_USER = stored;
        return stored;
      }
      const guest = createGuestSession();
      window.ATLAS_USER = guest;
      return guest;
    }

    /* ============================
       BUILD CONFIG
    ============================ */
    function buildConfig(mesa, k) {
      const cfg = {
        verify: { projectID: VOICEFLOW_PROJECT_ID },
        url: VOICEFLOW_RUNTIME_URL,
        versionID: 'production',
        locale: 'es',
        autostart: true
      };

      if (mesa || k) {
        cfg.launch = {
          event: {
            type: 'launch',
            payload: { ...(mesa && { mesa }), ...(k && { k }) }
          }
        };
      }

      cfg.userID =
        sessionStorage.getItem(SESSION_KEY) ||
        ('user-' +
          Date.now().toString(36) +
          '-' +
          Math.random().toString(36).slice(2, 7));

      sessionStorage.setItem(SESSION_KEY, cfg.userID);
      return cfg;
    }

    /* ============================
       STATE
    ============================ */
    window.ATLAS = window.ATLAS || {};
    window.ATLAS.state = window.ATLAS.state || {};
    window.ATLAS.data = window.ATLAS.data || {};

    if (window.ATLAS.state.__initialized !== true) {
      window.ATLAS.state.menuReady = false;
      window.ATLAS.state.chatOpened = false;
      window.ATLAS.state.menuShown = false;
      window.ATLAS.state.__initialized = true;
    }

    /* ============================
       INIT VF
    ============================ */
    async function initVF() {
    
      if (FLAGS.vfStarted && window.voiceflow?.chat) return;
      FLAGS.vfStarted = true;

      await waitForAtlasCore().catch(() => {
        FLAGS.vfStarted = false;
        return;
      });

      await initSessionEngine();

      const mesa =
        window.ATLAS?.utils?.getParamUrl?.('mesa') ||
        ATLAS.core?.runtime?.mesaFromUrl ||
        null;

      const k = ATLAS.core?.runtime?.runtimeK || null;

      const cfg = buildConfig(mesa, k);

      function waitForVF(max = 50) {
        return new Promise((resolve, reject) => {
          let tries = 0;

          const check = () => {
            if (window.voiceflow?.chat?.load) {
              resolve();
            } else if (++tries >= max) {
              reject("VF not loaded");
            } else {
              setTimeout(check, 100);
            }
          };
          check();
        });
      }
    
      await waitForVF().catch(() => {
        FLAGS.vfStarted = false;
        alert("VF FAILED TO LOAD");
        return;
      });

      window.voiceflow.chat.load(cfg).then(() => {

        setTimeout(() => {
          try { 
            window.voiceflow.chat.open(); 
          } catch {}
          setTimeout(markChatOpened, 800);
         }, 500);

      }).catch(() => {
        FLAGS.vfStarted = false;
      });
    }

    /* ============================
       MENU LOADER
    ============================ */
    const MENU_ENDPOINT = "https://script.google.com/macros/s/AKfycbzPsg4nN3MWyXyGLPXnPTJSEZvFVak4t87bTHw7ltM5j3z5DrvPITsEiedZvDp0-5wWQA/exec";
    const MENU_TOKEN = "GVP_IT_ML";

    function getKFromUrl() {
      const params = new URLSearchParams(window.location.search);
      return params.get("K") || "K0";
    }

    const MENU_K = getKFromUrl();
    const MENU_CACHE_KEY = "ATLAS_MENU_CACHE";

    function flattenMenu(groupedMenu) {
      const flat = [];
      Object.keys(groupedMenu || {}).forEach(cat => {
        groupedMenu[cat].forEach(item => {
          flat.push({ ...item, categoria: cat });
        });
      });
      return flat;
    }

    async function loadMenu() {
      const CACHE_TTL = 1000 * 60 * 5; // 5 minuti
      // ============================
      // 🧠 CACHE CHECK
      // ============================
      try {
        const cached = sessionStorage.getItem(MENU_CACHE_KEY);
        if (cached) {
          const parsed = JSON.parse(cached);
          if (parsed.ts && (Date.now() - parsed.ts < CACHE_TTL)) {
            window.ATLAS.data.menu = parsed.data;
            window.ATLAS.state.menuReady = true;
            return;
          } else {
            sessionStorage.removeItem(MENU_CACHE_KEY);
          }
        }
      } catch (e) {
        console.warn("Cache parse error", e);
      }
      // ============================
      // 🌐 FETCH
      // ============================
      try {
        const url = `${MENU_ENDPOINT}?token=${MENU_TOKEN}&K=${MENU_K}&mode=json&t=${Date.now()}`;
  
        const res = await fetch(url);
        const json = await res.json();
        const flat = flattenMenu(json.menu || {});

        window.ATLAS.data.menu = flat;
        window.ATLAS.state.menuReady = true;
        // 💾 SAVE CACHE
        try {
          sessionStorage.setItem(MENU_CACHE_KEY, JSON.stringify({
            ts: Date.now(),
            data: flat
          }));
        } catch {}
      } catch (e) {
        console.error("Menu fetch error", e);
      }
    }

    /* ============================
       START
    ============================ */
    window.ATLAS.data.menu = null;
    window.ATLAS.state.menuReady = false;
    loadMenu();

    (async () => {
      // aspetta menu pronto
      const waitMenu = () => new Promise(res => {
        const check = () => {
          if (window.ATLAS.state.menuReady) return res();
          setTimeout(check, 100);
        };
        check();
      });

      await waitMenu();

      // 🔥 mostra carosello PRIMA di VF
      await new Promise(resolve => {
        window.ATLAS.ui.showMenuCarousel(resolve);
      });

      // 🔥 SOLO DOPO parte VF
      initVF();

    })(); 
  }

  waitForAtlasAndStart();

})();
